export const AGENT_OUTCOME_COPY = {
  sectionTitle: 'Measure agent outcomes',
  sectionSubtitle: 'Count successful tool runs as metrics and connect them to the value your AI drives.',
  controlsLegend: 'Measurement options',
  enableLabel: 'Track successful runs',
  enableDescription: 'Count every successful run as a metric you can report on in Reach.',
  linkResourceLabel: 'Connect successful runs to revenue',
  linkResourceDescription:
    'Link each run to a synced record so Reach can attribute revenue and show the exact dollars driven by your AI.',
  schemaLabel: 'Linked record type',
  schemaHint: 'Choose the synced record type this tool returns, such as a booking or transaction.',
  missingSchema: 'Choose the record type you want to link.',
  chooseSchema: 'Choose a record type…',
  savedSchema: 'Saved record type',
  savedSchemaUnavailable: 'Saved record type is no longer available',
  unavailableSchema: 'Choose an active record type; the saved record type is no longer available.',
  loadingSchemas: 'Loading synced record types…',
  schemaLoadFailure: 'Synced record types could not be loaded.',
  retrySchemaLoad: 'Try again',
  noActiveSchemas:
    "You don't have an eligible synced record type yet. Set one up in Data Integration first, then come back.",
  requiredMappingTitle: 'Connect successful runs to revenue',
  requiredMappingDescriptionLead: 'Map the synced record’s ID to',
  requiredMappingDescriptionTail: 'so Reach can attribute revenue back to your AI.',
  requiredMappingSuggestionLead: 'Use',
  requiredMappingSuggestionConnector: 'as',
  requiredMappingSuggestionTail: 'for revenue attribution',
  requiredMappingSamplePrompt: 'Run a test or paste a sample response, then choose the record ID.',
  mappedResourceIdHint: 'Required for revenue attribution. This ID links the run to its synced record.',
} as const;

export const unreadableAgentOutcomeMessage = (marker: string | undefined): string =>
  marker
    ? `This tool has an unrecognized outcome tracking setting: "${marker}". Turn outcome tracking on or off to replace it.`
    : 'This tool links a record without enabling outcome tracking. Turn outcome tracking on or off to repair it.';

export const requiredAgentOutcomeMappingSuggestion = (
  suggestedPath: string,
  outputName: string,
): string => `Use ${suggestedPath} as ${outputName}`;
